export default "__VITE_ASSET__BzJcya10__"